<template>
  <div class="table-wrapper cover-content project-list">
    <div class="boxList" v-loading="loading">
      <Row>
        <Col :span="6">
          <div style="font-size: 28px; font-weight: 900">
            项目名称: {{ projectName }}
          </div>
        </Col>
      </Row>
      <div class="boxConter">
        <Form
          ref="formCustom"
          :model="formCustom"
          :label-width="110"
          :rules="ruleValidate"
        >
          <FormItem label="正式APP ID:" prop="appid">
            <Input
              type="text"
              v-model="formCustom.appid"
              :disabled="!showModal"
            ></Input>
          </FormItem>
          <FormItem label="正式密钥:" prop="secret">
            <Input
              type="text"
              v-model="formCustom.secret"
              :disabled="!showModal"
            ></Input>
          </FormItem>
          <FormItem label="正式地址:" prop="pushUrl">
            <Input
              type="text"
              v-model="formCustom.pushUrl"
              :disabled="!showModal"
            ></Input>
          </FormItem>
          <FormItem style="text-align: right">
            <Button v-if="!showModal" type="primary" @click="showModal=true"
              >编辑</Button
            >
            <Button
              v-if="showModal"
              type="primary"
              @click="handleReset('formCustom')"
              style="margin-left: 8px"
              >保存</Button
            >
            <Button
              v-if="showModal"
              @click="handleSubmit(false)"
              style="margin-left: 8px"
              >取消</Button
            >
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formCustom: {
        appid: "",
        secret: "",
        pushUrl: "",
      },
      ruleValidate: {
        appid: [
          {
            required: true,
            message: "请填写正式APP ID",
            trigger: "blur",
          },
        ],
        secret: [
          {
            required: true,
            message: "请填写正式密钥",
            trigger: "blur",
          },
        ],
        pushUrl: [
          {
            required: true,
            message: "请填写正式地址",
            trigger: "blur",
          },
        ],
      },
      systemId: "",
      loading: true,
      projectId: "",
      projectName: "",
      showModal: false,
      rowDataList: [],
    };
  },
  created() {
    (this.projectId = this.$route.query.projectId),
      (this.projectName = this.$route.query.projectName),
      (this.systemId = this.$route.query.systemId);
    this.getPushDetails();
  },
  methods: {
    getPushDetails() {
      this.loading = true;
      this.axios({
        method: "get",
        url: "/push/getPushDataProjectSecret",
        params: {
          projectId: this.projectId,
          systemId: this.systemId,
        },
      }).then((response) => {
        this.loading = false;
        if (response.data.success) {
          this.formCustom = response.data.data;
        }
      });
    },
    handleSubmit(val) {
      this.$refs.formCustom.resetFields();
      this.showModal = val;
      this.getPushDetails();
    },
    handleReset() {
      this.$refs.formCustom.validate((valid) => {
        if (valid) {
          this.loading = true;
          let data = {
            projectId: this.projectId,
            pushSystemId: this.systemId,
            pushUrl: this.formCustom.pushUrl,
            appid: this.formCustom.appid,
            secret: this.formCustom.secret,
          };
          this.axios({
            method: "post",
            url: "/push/savePushDataProjectSecret",
            data,
          }).then((response) => {
            this.loading = false;
            if (response.data.success) {
              this.showModal = false;
              this.$Message.success("保存成功！");
            } else {
              this.$Message.success("保存失败！");
            }
            this.getPushDetails();
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.boxList {
  margin: 24px;
  .boxConter {
    margin-top: 40px;
    width: 30%;
  }
}
</style>
